import { useState, useRef, useEffect } from 'react';
import { FIELDS } from '../../lib/windgram';

// A "?" help button in the windgram tab bar that opens a popover explaining the
// CURRENTLY active tab: what it shows + how to read it. Content is i18n'd under
// the `wgHelp.<field>` keys; the title reuses the active tab's own label.
// (React overlay rather than the Skew-T's d3 drawHelpIcon: the windgram SVG is
// zoom/clip-transformed, so a DOM popover avoids being clipped or scaled.)
const WindgramHelp = ({ field, t }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDoc);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDoc);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    const f = FIELDS[field];
    if (!f) return null;

    return (
        <div ref={ref} className="relative">
            <button
                type="button"
                aria-label={t('Help')}
                title={t('Help')}
                onClick={() => setOpen((o) => !o)}
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white text-xs font-bold shadow-md
                    ${open ? 'bg-blue-600' : 'bg-slate-600 hover:bg-slate-700'}`}
            >
                ?
            </button>
            {open && (
                <div className="absolute right-0 top-9 z-[1200] w-72 max-w-[80vw] rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl p-3 text-sm text-slate-700 dark:text-slate-200">
                    <div className="font-semibold mb-2">{t(f.label)}</div>
                    <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-0.5">
                        {t('What it shows')}
                    </div>
                    <p className="mb-2 leading-snug">{t(`wgHelp.${field}.what`)}</p>
                    <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-0.5">
                        {t('How to read it')}
                    </div>
                    <p className="leading-snug">{t(`wgHelp.${field}.read`)}</p>
                </div>
            )}
        </div>
    );
};

export default WindgramHelp;
